<template>
    <div class="signup-form" @keyup.enter="signup()">
        <h2>Sign Up</h2>
        <div v-if="signedUp">Please check your email for a confirmation link.</div>
        <input type="text" placeholder="Email" v-model="newUser.email" v-if="!signedUp">
        <input type="password" placeholder="Password" v-model="newUser.password" v-if="!signedUp">
        <Button @click="signup()" v-if="!signedUp">Sign Up</Button>
        <div>- or -</div>
        <router-link to="/login">Login</router-link>
    </div>
</template>

<script>
    import Button from '../components/Button';

    export default {
        methods: {
            signup: function() {
                this.signedUp = true;
                this.$store.dispatch('users/signupUser', this.newUser);
            }
        },
        components: {
            Button
        },
        data() {
            return {
                newUser: {},
                signedUp: false
            };
        },
    };
</script>

<style lang="scss">
    .signup-form {
        * {
            display: block;
            margin: auto;
            margin-bottom: $space-32;

            width: $space-256;
        }

        *:last-child {
            margin-bottom: 0;
        }
    }
</style>